/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import RequestService from '../service/requestService';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import { clearConsentDocumentsForSoP } from './document.status.optinoptout.actions';

export const hide = () => {
  return {
    type: actionTypes.DOCUMENT_STATUS_VIEW__HIDE
  };
};

export const show = (consentGid, consentName, currentStatus) => {
  return {
    type: actionTypes.DOCUMENT_STATUS_VIEW__SHOW,
    payload: { documentId: consentGid, documentName: consentName, currentStatus: currentStatus }
  };
};

export const showError = (error) => {
  return {
    type: actionTypes.DOCUMENT_STATUS_VIEW__ERROR,
    payload: error
  };
};

export const loadDocumentStatuses = (consentingGid) => (dispatch) => {
  dispatch(fetchingDocumentStatuses());
  return RequestService.getDocumentStatuses(consentingGid)
    .then((response) => {
      dispatch(getDocumentStatuses(response.data.statuses));
    })
    .catch((err) => {
      dispatch(showError(err));
    });
};

export const getDocumentStatuses = (statuses) => {
  return {
    type: actionTypes.DOCUMENT_STATUSES__FETCH,
    payload: statuses
  };
};

export const saveStatus = (formData, isProtected) => (dispatch) => {
  dispatch(fetchingDocumentStatuses());
  return RequestService.saveDocumentStatus(formData.documentId, formData.status, isProtected, formData)
    .then((response) => {
      dispatch(actions.fetchDocuments({ studyId: formData.studyGid, participantId: formData.participantId }));
      dispatch(actions.fetchParticipantJourney(response.data.participant.participantJourneyGid));
      dispatch(actions.hideModal());
      dispatch(clearConsentDocumentsForSoP());
    })
    .catch((err) => {
      dispatch(showError(err));
    });
};

export const saveDocumentStatus = () => {
  return {
    type: actionTypes.DOCUMENT_STATUS__SAVE
  };
};

export const fetchingDocumentStatuses = () => {
  return {
    type: actionTypes.DOCUMENT_STATUS_VIEW__LOADING
  };
};
